import {TempusDominus} from "@eonasdan/tempus-dominus";

export default abstract class AbstractDateTimePicker {
    protected target: HTMLElement;

    constructor(target: HTMLElement) {
        this.target = target;
    }

    public createPicker(): void {
        // Hide element and remove input value temporarily, because the picker can't be initialized in case of invalid value
        $(this.target).hide();
        const $inputElement = $('input', $(this.target));
        const inputValue = $inputElement.val();
        $inputElement.val('');

        // Initialize picker
        const mergedOptions = $.extend(true, this.options(), $(this.target).data('picker-options') ?? {});
        const picker = new TempusDominus(this.target, mergedOptions);

        // Revert temporary changes
        $inputElement.val(inputValue);
        $(this.target).show();

        // Handle invalid value when input changes. There should be another way to handel this in the next release: https://github.com/Eonasdan/tempus-dominus/issues/2793
        // @ts-ignore
        picker.dates.previousParseInput = picker.dates.parseInput;
        picker.dates.parseInput = (value: any) => {
            try {
                // @ts-ignore
                return picker.dates.previousParseInput(value);
            } catch (e) {
                // Don't do anything, just keep the previous value
            }
        };

    }

    protected options(): {} {
        return {
            useCurrent: false,
            display: {
                keepOpen: false,
                buttons: {
                    today: false,
                    clear: true,
                    close: true,
                },
                components: {
                    date: true,
                    month: true,
                    year: true,
                    decades: true,
                    hours: true,
                    minutes: true,
                    seconds: false,
                },
                theme: 'light'
            },
            localization: {
                hourCycle: 'h23',
            },
        };
    }
}